<script>
import { mapActions } from 'vuex';
import mainViewTabMixin from '../../mixins/mainViewTab';
import snackbarMixin from '../../mixins/snackbar';
import CompanyBasicInfoForm from './components/CompanyBasicInfoForm';
import CompanyPrivacyOfficerForm from './components/CompanyPrivacyOfficerForm';
import Documents from './components/Documents';
import History from '../history';

export default {
  name: 'CompanyDetails',
  components: {
    CompanyBasicInfoForm,
    CompanyPrivacyOfficerForm,
    Documents,
    History,
  },
  mixins: [mainViewTabMixin, snackbarMixin],
  data() {
    return {
      query: {},
      params: {},
      company: {},
      isLoading: false,
      isSaving: false,
      hasError: false,
      activeTab: 0,
    };
  },
  created() {
    const { query, params } = this.urlParser('/company/show/:id?', this.path);

    this.query = query;
    this.params = params;
    this.fetchData();
  },
  methods: {
    ...mapActions('companyDetails', ['fetchCompany', 'saveCompany']),
    fetchData() {
      this.isLoading = true;
      this.hasError = false;

      return this.fetchCompany(this.params.id)
        .then(({ data }) => {
          this.company = data;
          this.updateTabTitle({ path: this.path, title: this.company.name });
        })
        .catch(() => {
          this.hasError = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    save() {
      this.isSaving = true;

      return this.saveCompany(this.company)
        .then(() => {
          this.showSuccessMessage('Firma erfolgreich gespeichert!');
        })
        .catch(() => {
          this.showErrorMessage('Firma konnte nicht gespeichert werden. Bitte versuche es erneut!');
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
  },
};
</script>

<template>
  <div class="company-detail">
    <v-progress-linear v-if="isLoading" :indeterminate="true"/>

    <span
      v-else-if="hasError"
      class="js-error ma-3"
    >An error occurred while fetching company information</span>

    <template v-else>
      <v-toolbar dark dense height="40" color="blue-grey lighten-2">
        <v-tooltip bottom>
          <v-btn @click="fetchData" icon slot="activator">
            <v-icon>refresh</v-icon>
          </v-btn>
          <span>Aktualisieren</span>
        </v-tooltip>
        <v-tooltip bottom>
          <v-btn @click="save" :loading="isSaving" icon slot="activator">
            <v-icon>save</v-icon>
          </v-btn>
          <span>Speichern</span>
        </v-tooltip>
      </v-toolbar>

      <v-form>
        <v-container fluid grid-list-lg pt-2 pa-0>
          <v-tabs v-model="activeTab" height="35" slider-color="black" color="amber">

            <v-tab ripple>Verantwortlicher</v-tab>
            <v-tab ripple>Datenschutzbeauftragter</v-tab>
            <v-tab ripple>Dokumente</v-tab>
            <v-tab ripple>Historie</v-tab>

            <v-tab-item>
              <CompanyBasicInfoForm :company="company" @save="save" />
            </v-tab-item>

            <v-tab-item>
              <CompanyPrivacyOfficerForm :company="company" @save="save"/>
            </v-tab-item>

            <v-tab-item>
              <Documents
                :resource="'company'"
                :id="company.id"
                :allowed-file-types="['csv', 'doc', 'pdf', 'rtf', 'tex', 'txt', 'xlsx']"
              />
            </v-tab-item>

            <v-tab-item>
              <History :domain="'company'" :domain-id="company.id" path="/history" />
            </v-tab-item>

          </v-tabs>
        </v-container>
      </v-form>
    </template>
  </div>
</template>

<style lang="scss">
.company-detail {
  &-title {
    margin-bottom: 10px;
  }

  &-actions {
    margin: 5px 0;

    .v-btn:first-child {
      border-radius: 5px 0 0 5px;
    }

    .v-btn:last-child {
      border-radius: 0 5px 5px 0;
    }

    .v-btn + .v-btn {
      border-left: 1px solid #fff !important;
    }

    .v-btn {
      margin: 0;
      width: 35px;
      height: 35px;
      border-radius: 0px;
    }
  }

  &-tab {
    padding-top: 10px;

    &-title {
      margin-bottom: 10px;
    }
  }

  &-common-list {
    margin-top: 5px;
    .v-btn {
      margin: 0px;
      width: 30px;
      height: 30px;
    }

    &-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
    }

    &-item {
      display: flex;
      align-items: center;
      justify-content: space-between;

      &:hover {
        .v-btn {
          opacity: 1;
        }
      }

      .v-btn {
        opacity: 0;
      }
    }
  }

  .v-tabs {
    &__items {
      padding-bottom: 30px;
    }
  }

  .submit-button {
    margin-top: 20px;
  }
}
</style>
